import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { Link } from 'react-router'
import i18next from 'i18next'
import GridContainer from './GridContainer'
import SmallButton from './SmallButton'
import buttonStyles from './styles/button.scss'
import listingStyles from './styles/listing.scss'

function isAdmin(account) {
  return account.organisations.some(o => o.roles.indexOf('admin') !== -1)
}

export default class AccountList extends React.Component {
  handleDeleteAccount = account => () => {
    if (confirm(i18next.t('are_you_sure'))) {
      this.props.onDelete(account.id)
    }
  }

  isDeleted = account => {
    return this.props.deletedAccountIds.contains(account.id)
  }

  render() {
    const { isSuperAdminView, accounts, onPromoteToAdmin, currentAccount } = this.props

    const link = isSuperAdminView ? '/admin/accounts/new' : '/management/accounts/new'

    return (
      <GridContainer>
        <Row>
          <Col md={12}>
            <header>
              <h1>{i18next.t('accounts')}</h1>

              <Link to={link} className={buttonStyles.button} style={{ marginLeft: 20 }}>
                {i18next.t('new_account')}
              </Link>
            </header>

            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    {isSuperAdminView && <th>ID</th>}
                    <th>{i18next.t('family_name')}</th>
                    <th>{i18next.t('given_name')}</th>
                    <th>{i18next.t('email')}</th>
                    {isSuperAdminView && <th>{i18next.t('organisation')}</th>}
                    {isSuperAdminView && <th>{i18next.t('is_super_admin')}</th>}
                    {onPromoteToAdmin && <th>{i18next.t('privileges')}</th>}
                    <th>{i18next.t('activation_link')}</th>
                    <th>{i18next.t('delete_account')}</th>
                    <th>{i18next.t('invitation_sent')}</th>
                  </tr>
                </thead>

                <tbody>
                  {accounts.map((account, key) => (
                    <tr key={key} className={this.isDeleted(account) && listingStyles.deleted}>
                      {isSuperAdminView && <td>{account.id}</td>}
                      <td>{account.familyName}</td>
                      <td>{account.givenName}</td>
                      <td>{account.email}</td>
                      {isSuperAdminView && (
                        <td>{account.organisations.map(o => o.organisation.name).join(', ')}</td>
                      )}
                      {isSuperAdminView && <td>{account.isSuperAdmin && i18next.t('yes')}</td>}
                      {onPromoteToAdmin && (
                        <td>
                          {!isAdmin(account) && (
                            <SmallButton
                              text={i18next.t('promote_to_admin')}
                              onClick={() => onPromoteToAdmin(account.id)}
                            />
                          )}

                          {isAdmin(account) && <span>{i18next.t('admin_privileges')}</span>}
                        </td>
                      )}
                      <td>
                        {!account.verifiedAt && (
                          <Link to={`/verify/${account.verificationToken}`}>
                            {i18next.t('activation_link')}
                          </Link>
                        )}
                      </td>
                      <td>
                        {!account.isSuperAdmin &&
                          currentAccount.id !== account.id &&
                          !this.isDeleted(account) && (
                            <SmallButton
                              text={i18next.t('delete_account')}
                              onClick={this.handleDeleteAccount(account)}
                            />
                          )}

                        {this.isDeleted(account) && <span>{i18next.t('deleted')}</span>}
                      </td>
                      <td>{account.invitationSentAt ? i18next.t('yes') : i18next.t('no')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Col>
        </Row>
      </GridContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/AccountList.js